// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3gIVC","content":"styles_content__1P7Bm","checkbox":"styles_checkbox__1wrwN","checkboxLabel":"styles_checkboxLabel__13aYq"};